module.exports = "pegasus_template/assets/column-7-basic.png";